
const ErrorPage = (props) =>{
    return (
        <div style={{textAlign:"center",color:"red"}}>
          <h1 style={{color:'red'}}>Oops! Something went wrong.</h1>
          <p>{props.errorMessage}</p>
        </div>
      );
}
export default ErrorPage;